export type PaymentMethod = {
    type: PaymentType
    label: string,
}

export enum PaymentType {
    'uponDelivery' = 'upon-delivery',
    'dolyame' = 'dolyame',
    'card' = 'card',
    'sbp' = 'sbp',
}
